import { FooterCard, Infomation, MobileModal, ViewPager } from "../../component";
import { useAppDispatch, useAppState, useAppTranslation, useWindowDimensions } from "../../hook";
import { Link } from "react-router-dom";
import { FoundCard } from "./found-card";
import { Menu } from "../../enum";
import { ManagementModal } from "../company/constants";
import { PortfolioManagement } from "./constants/portfolio-managment";
import { Helmet } from "react-helmet-async";
import "./managers.page.scss";
import { ProfileCard } from "./profile-card/profile.card";

export const Managers = () => {
    const dispatch = useAppDispatch();
    const { t } = useAppTranslation();
    const { width } = useWindowDimensions();

    const [state, setState] = useAppState({
        modalVisible: false,
        managerId: 0,
    });

    const handleModalVisible = (id: number) => {
        setState((prevState) => ({ ...prevState, modalVisible: !state.modalVisible }));
        if (id) {
            setState((prevState) => ({ ...prevState, managerId: id }));
        }

        document.body.style.overflow = "";
    };

    const getTopProfileCards = () => {
        var cards: React.ReactElement[] = [];

        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_bakk_ferenc_title")}
                position={t("managers_bakk_ferenc_position_title")}
                imageUrl={"/image/bakk_ferenc.jpg"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(5)}
                id={4}
            />
        );
        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_heinz_frigyes_title")}
                position={t("managers_heinz_frigyes_position_title")}
                imageUrl={"/image/heinz_frigyes.png"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(4)}
                id={3}
            />
        );

        return cards;
    };

    const getBottomProfileCards = () => {
        var cards: React.ReactElement[] = [];

        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_nemesi_peter_title")}
                position={t("managers_nemesi_peter_position_title")}
                imageUrl={"/image/nemesi_peter.jpg"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(6)}
                id={5}
            />
        );
        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_szombathy_adam_title")}
                position={t("managers_szombathy_adam_position_title")}
                imageUrl={"/image/szombathy_adam.jpg"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(7)}
                id={6}
            />
        );

        return cards;
    };

    const getBottomBottomProfileCards = () => {
        var cards: React.ReactElement[] = [];

        return cards;
    };

    const getAllProfileCards = () => {
        var cards: React.ReactElement[] = [];

        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_bakk_ferenc_title")}
                position={t("managers_bakk_ferenc_position_title")}
                imageUrl={"/image/bakk_ferenc.jpg"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(5)}
                id={4}
            />
        );
        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_heinz_frigyes_title")}
                position={t("managers_heinz_frigyes_position_title")}
                imageUrl={"/image/heinz_frigyes.png"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(4)}
                id={3}
            />
        );
        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_nemesi_peter_title")}
                position={t("managers_nemesi_peter_position_title")}
                imageUrl={"/image/nemesi_peter.jpg"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(6)}
                id={5}
            />
        );
        cards.push(
            <ProfileCard
                title={t("managers_managers_title")}
                name={t("managers_szombathy_adam_title")}
                position={t("managers_szombathy_adam_position_title")}
                imageUrl={"/image/nemesi_peter.jpg"}
                buttonTitle={t("management_card_introduction_button_title")}
                setModalVisible={() => handleModalVisible(7)}
                id={6}
            />
        );

        return cards;
    };

    const getFoundCards = () => {
        var cards: React.ReactElement[] = [];

        cards.push(
            <FoundCard
                key={0}
                title={t("managers_found_otp_climate_title")}
                buttonTitle={t("managers_details_button")}
                url={"https://www.otpbank.hu/otpalapkezelo/en/Klimavaltozas"}
            />
        );
        cards.push(
            <FoundCard
                key={1}
                title={t("managers_found_otp_trend_title")}
                buttonTitle={t("managers_details_button")}
                url={"https://www.otpbank.hu/otpalapkezelo/hu/A_Trend"}
            />
        );
        cards.push(
            <FoundCard
                key={2}
                title={t("managers_found_otp_omega_title")}
                buttonTitle={t("managers_details_button")}
                url={"https://www.otpbank.hu/otpalapkezelo/hu/A_Omega"}
            />
        );
        cards.push(
            <FoundCard
                key={3}
                title={t("managers_found_otp_absolute_title")}
                buttonTitle={t("managers_details_button")}
                url={"https://www.otpbank.hu/otpalapkezelo/hu/A_AbszolutHozam"}
            />
        );
        cards.push(
            <FoundCard
                key={4}
                title={t("managers_found_otp_absolute_euro_title")}
                buttonTitle={t("managers_details_button")}
                url={"https://www.otpbank.hu/otpalapkezelo/hu/A_AbszolutHozamEuro"}
            />
        );

        return cards;
    };

    const onMenuItemClick = (id: number) => {
        dispatch({
            type: "BASE_CHANGE_MENU",
            id: id,
        });
    };

    return (
        <main className="page page-managers">
            <Helmet>
                <title>OTP Multiasset - Managers </title>
                <meta name="description" content="OTP Multiasset - Managers" />
            </Helmet>
            <div className="main-div">
                <div className="top-container">
                    <div className="coworker-container">
                        {/* <h1 className="title-text">{t('managers_coworker_title')}</h1> */}

                        <div className="coworker-profile-container">
                            {width <= 576 ? <ViewPager cards={getAllProfileCards()} /> : <>{getTopProfileCards().map((card) => card)}</>}
                        </div>

                        <div className="coworker-profile-container top-margin">
                            {width <= 576 ? null : <>{getBottomProfileCards().map((card) => card)}</>}
                        </div>
                    </div>
                </div>

                <div className="middle-container">
                    <div className={`middle-container-bg ${window?.visualViewport!!.width < width ? `` : `full-width`}`} />

                    <div className="middle-container-inner">
                        <h2 className="title-text-h2">{t("managers_czachesz_gabor_founds_title")}</h2>

                        <div className="founds-container">
                            {width <= 852 ? <ViewPager cards={getFoundCards()} /> : <>{getFoundCards().map((card) => card)}</>}
                        </div>
                    </div>
                </div>

                <div className="bottom-container">
                    <div className="afterword">
                        <h3>{t("founds_page_landing_page_afterwords")}</h3>
                    </div>

                    <Link
                        className="middle-container-button-link"
                        to={"/alapok"}
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0 });

                            onMenuItemClick(Menu.Founds);
                        }}
                    >
                        <button className="button">{t("header_menu_founds_button")}</button>
                    </Link>
                </div>

                {width <= 576 ? (
                    <>
                        <FooterCard />
                        <Infomation />
                    </>
                ) : (
                    <>
                        <Infomation />
                        <FooterCard />
                    </>
                )}

                {state.modalVisible && width > 576 ? (
                    <ManagementModal
                        url={PortfolioManagement[state.managerId - 1].imageUrl}
                        title={t(PortfolioManagement[state.managerId - 1].name)}
                        description={t(PortfolioManagement[state.managerId - 1].description)}
                        postDescription={t(PortfolioManagement[state.managerId - 1].postDesctription)}
                        onCloseClick={() => handleModalVisible(NaN)}
                    />
                ) : (
                    state.modalVisible &&
                    width <= 576 && (
                        <MobileModal
                            visible={state.modalVisible}
                            title={t(PortfolioManagement[state.managerId - 1].name)}
                            description={t(PortfolioManagement[state.managerId - 1].description)}
                            postDescription={t(PortfolioManagement[state.managerId - 1].postDesctription)}
                            hideButton={true}
                            onCloseClick={() => handleModalVisible(NaN)}
                        />
                    )
                )}
            </div>
        </main>
    );
};
